import React from 'react'
import { Col, Row, Container } from "react-bootstrap"
import { Link } from "gatsby"
import Typewriter from 'typewriter-effect';
const Inicio = ({ id }) => {



    return (
        <header className="masthead" id={id}>
            <Container >
                <Row >
                    <Col md={{ span: 6, offset: 6 }} >
                        <h1
                            data-sal="slide-up"
                            data-sal-delay="600"
                            data-sal-easing="easeInQuad"
                            className="anim-2s"
                        //style="--sal-duration: 3s; --sal-delay: 2s;"
                        >

                            <Typewriter

                                options={{
                                    strings: 'Enfoca tu tiempo en tu <b>negocio</b>, <br/>del software y la tecnología <br/><b class="resaltado-inicio">nos encargamos nosotros_</b>',
                                    autoStart: true,
                                    loop: false,
                                    delay: 45,
                                    cursorClassName: 'hide'
                                }}
                            />

                        </h1>
                        <br />
                        <p
                            data-sal="slide-up"
                            data-sal-delay="700"
                            data-sal-easing="easeInQuad"
                            className="anim-2s"
                        >
                            Somos una empresa de tecnología que cuenta con soluciones de software y plataformas integrales de primer nivel. Contamos con presencia en todo el país y con una amplia gama de productos orientados a cubrir las necesidades de tu empresa
                        </p>
                        {/* <Link to="/nosotros" className="btn btn-outline-primary">Conoce más de nosotros acá</Link> */}
                        <p
                            data-sal="slide-up"
                            data-sal-delay="800"
                            data-sal-easing="easeInQuad"
                            className="anim-2s"
                        >
                            <br />
                            <Link to="/nosotros">MÁS SOBRE NOSOTROS</Link>
                        </p>

                    </Col>




                </Row>
            </Container>
        </header>

    )
}

export default Inicio
